import { VIDEO_LOW_STREAM_CONFIG, VIDEO_LOW_STREAM_CONFIG_240P } from '../const';

export function selectLowStreamConfig(bandwidthKbps) {
  const bw = parseInt(bandwidthKbps, 10);
  if (!isNaN(bw) && bw >= 1000 && bw <= 2000) {
    return VIDEO_LOW_STREAM_CONFIG_240P;
  }
  return VIDEO_LOW_STREAM_CONFIG;
}
